export default __webpack_public_path__ + "static/media/livenyte-glitched_cmprs.2609e067.png";